import { GetterTree } from 'vuex';
import ILocalState from './stateInterface';
import Client from '@/models/Client';
import ContactPerson from '@/models/ContactPerson';
import { AddressValidationQuota } from '@/modules/Client/Interfaces/AddressValidation';

const getters: GetterTree<ILocalState, {}> = {
    validationRequestsRemaining(state): number | null {
        return state.validationRequestsQuota?.remaining ?? null;
    },
    validationRequestsQuota(state): AddressValidationQuota | null {
        return state.validationRequestsQuota;
    },
    projectClientCreation(state): boolean {
        return state.projectClientCreation;
    },
    createdClient(state): Client | null {
        return state.createdClient;
    },
    createdContacts(state): ContactPerson[] {
        return state.createdContacts;
    },
    calendarPopup(state): boolean {
        return state.calendarPopup;
    },
    unreadNotificationsCount(state): number {
        return state.unreadNotifications;
    },
    sidebarCollapsed(state): boolean {
        return state.sidebarCollapsed;
    },
    innerWidth(state): number {
        return state.innerWidth;
    },
    isGlobalNotificationVisible(state): boolean {
        return state.isGlobalNotificationVisible;
    },
    isLoginAlertVisible(state): boolean {
        return state.isLoginAlertVisible;
    },
};

export default getters;
